import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ServiceTypeActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Shop/ServiceType/ServiceTypeBrowser")
	}

	render() {
		return (
			<Activity 
				name="ServiceType"
				RenderedComponent={this.RenderedComponent}
				context="ServiceType"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ServiceTypeActivity)
